module.exports = __webpack_public_path__ + "eu-flag.svg";